module.exports = __webpack_public_path__ + "static/media/lens1_blue.b45a10f0.png";